export const API_GW_PAGE_URL = "/api-gateway";
export const thoughtworksApiUserGuideUrl = `${API_GW_PAGE_URL}/api-user-guide`;
export const mnpiInfoUrl = "https://docs.google.com/presentation/d/1jtvtamSG6_VmCO0Ra43k7A8un_1qfgwkvRCNjkaKsog/edit#slide=id.ge8d3a84380_1_0";
export const piiInfoUrl = "https://docs.google.com/presentation/d/1jtvtamSG6_VmCO0Ra43k7A8un_1qfgwkvRCNjkaKsog/edit#slide=id.gc3bb6c2245_0_414";
